var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgFactoryOutline = function SvgFactoryOutline(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none",
    display: "block",
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 22 22",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3d96ff",
    d: "M4.23 19.251q-.615 0-1.047-.433a1.43 1.43 0 0 1-.433-1.048v-7.023q0-.444.236-.823.237-.38.658-.555l2.653-1.115A.76.76 0 0 1 7 8.306q.333.199.333.615v.687l3.57-1.434a.7.7 0 0 1 .692.074.71.71 0 0 1 .322.615v1.221h7.333v7.686q0 .616-.433 1.048a1.43 1.43 0 0 1-1.048.433zm0-.917h13.54a.55.55 0 0 0 .405-.158.55.55 0 0 0 .158-.406v-6.769H11v-1.88l-4.583 1.834V9.168L4.002 10.24a.56.56 0 0 0-.247.203.54.54 0 0 0-.088.308v7.018q0 .247.158.406a.55.55 0 0 0 .406.158m6.065-2.256h1.41v-2.82h-1.41zm-3.667 0h1.41v-2.82h-1.41zm7.333 0h1.41v-2.82h-1.41zm5.289-5.994h-2.856l.86-6.178a.5.5 0 0 1 .175-.327.52.52 0 0 1 .35-.123h.264q.167 0 .287.115.12.114.148.282zm-15.02 8.25h-.563 14.666z"
  })));
};
export default SvgFactoryOutline;